export const colors = [
    { name: 'Blue 20', color: '#72aee6' },
    // ...
];